import React, { useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
import ErrorBoundary from 'components/ErrorBoundary';

const ThirdPartyCase = ({months,thirdParty,cash}) => {
  const [active, setActive] = useState('12');

  const chartData = {
    labels: months,
    datasets: [
      {
        label: 'Third Party',
        data: thirdParty,
        borderColor: 'rgba(62, 141, 209, 1)',
        backgroundColor: 'rgba(62, 141, 209, 1)',
        categoryPercentage: 0.35,
      },
      {
        label: 'Cash',
        data: cash,
        borderColor: 'rgba(19, 75, 123, 1)',
        backgroundColor: 'rgba(19, 75, 123, 1)',
        categoryPercentage: 0.35,
      },
    ],
  };

  const handleActive = (title) => {
    setActive(title);
  };

  const plugin = {
    beforeInit(chart) {
      console.log('be');
      // Get reference to the original fit function
      const originalFit = chart.legend.fit;
  
      // Override the fit function
      chart.legend.fit = function fit() {
        // Call original function and bind scope in order to use `this` correctly inside it
        originalFit.bind(chart.legend)();
        // Change the height as suggested in another answers
        this.height = this.height + 25;
      };
    },
  };

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          title: function (item,index) {
            const {label} =item[0].dataset;
            return `${item[0].label} \n ${label}`;
          },
            label: function (d,t) {
            var xLabel = "Dispense Fee Revenue";
            var yLabel ='$' + d.formattedValue;
            return xLabel + ': ' + yLabel;
          },
        },
      },
      legend: {
        position: 'top',
        labels: {
          padding: 15,
          usePointStyle: true,
          pointStyle: 'rect',
          color: '#707070',
          font: {
            weight: 'bold',
          },
        },
        align: 'start',
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
    },
  };

  const getDate = () => {
   setActive("custom");
  };

  return (
    <ErrorBoundary>
      <Card className='p-3 h-100'>
        <CardHeader className='border-0 bg-white'>
          <Row className='align-items-center'>
            <Col>
              <CardTitle className='f-20 font-weight-500 mb-0'>
                Third Party vs. Cash
              </CardTitle>
            </Col>
            <Col xs='auto'>
              <Nav className='widget-tabs'>
              </Nav>
            </Col>
          </Row>
        </CardHeader>
        <CardBody className='dashboard-chart-body'>
         <div className='dashboard-chart-height'>
         <Bar options={options} data={chartData} plugins={[plugin]}/>
         </div>
         {/* <span>2022</span> */}
        </CardBody>
      </Card>
    </ErrorBoundary>
  );
};

export default ThirdPartyCase;
